import {
  IPossibleDeliveryDate,
  ISubscriptionOverview,
} from "@api-clients/subscriptions";
import dayjs, { Dayjs } from "dayjs";
import { sortDayJsDates } from "libs/utils/misc/src/dates";

import {
  getAllDeliveryDatesFromSubscriptionOverview,
  hasSubscriptionsOverviewGotCancelledPlansOnly,
} from "libs/utils/subscriptions/state";

export type TUseNextDeliveryDate = {
  nextAvailable: Dayjs | undefined;
  nextScheduled: Dayjs | undefined;
};

export type TNextDeliveryDateOption = keyof TUseNextDeliveryDate;

export const useNextDeliveryDate = (
  availableDates?: IPossibleDeliveryDate[],
  subscriptions?: ISubscriptionOverview,
): TUseNextDeliveryDate => {

  if (!availableDates || !subscriptions) {
    return {
      nextAvailable: undefined,
      nextScheduled: undefined,
    };
  }

  const firstPossibleDeliveryDate = availableDates[0]
    ? dayjs(availableDates[0].date)
    : undefined;

  if (hasSubscriptionsOverviewGotCancelledPlansOnly(subscriptions)) {
    return {
      nextAvailable: firstPossibleDeliveryDate,
      nextScheduled: firstPossibleDeliveryDate,
    };
  }

  const scheduledDeliveryDates = getAllDeliveryDatesFromSubscriptionOverview(subscriptions);
  const sortedScheduledDeliveryDates = sortDayJsDates(scheduledDeliveryDates);

  const nextScheduled = sortedScheduledDeliveryDates.find((scheduledDate) =>
    availableDates.some(({ date }) => scheduledDate.isSame(date, "day")),
  );


  return {
    nextAvailable: firstPossibleDeliveryDate,
    nextScheduled,
  };
};
